import { ArrowsDownUp } from '@phosphor-icons/react';

export default ArrowsDownUp;
